export function roundShadowValue(value: number | undefined | null, decimals: number) {
  if (value === undefined || value === null || Number.isNaN(value)) {
    return 'N/A';
  }
  switch (decimals) {
    case 0:
      return Math.round(value);
    case 1:
      return (Math.round(value * 10) / 10).toFixed(decimals);
    case 2:
      return (Math.round(value * 100) / 100).toFixed(decimals);
    case 3:
      return (Math.round(value * 1000) / 1000).toFixed(decimals);
    default:
      return value;
  }
}